window.footerNavigation = {
    $footer: null,
    $footerLvl1: null,

    /**
     * Initialize Mobile Navigation
     */
    initMobileNav: function() {
        this.$footer = document.querySelector(".footer");
        this.$footerLvl1 = this.$footer.querySelectorAll('.level1');

        this.$footerLvl1.forEach(function (item){
            var $lvl1Span = item.querySelector(".level1__headline"),
                $lvl1SubLevel = item.querySelector(".level2__mobile");

            $lvl1Span.addEventListener('click', function () {
                if($lvl1SubLevel.classList.contains("level2__mobile--active")) {
                    window.footerNavigation.initCloseMobileNav();
                }
                else {
                    window.footerNavigation.initCloseMobileNav();
                    $lvl1SubLevel.classList.toggle("level2__mobile--active");
                    $lvl1Span.classList.toggle("level1__headline--active");
                }
            });
        });
    },

    /**
     * Close all Level2 Active Elements
     */
    initCloseMobileNav: function () {
        var $footerLvl2MobileActive = document.querySelector(".level2__mobile--active"),
            $footerLevel1MobileActive = document.querySelector(".level1__headline--active");

        if($footerLvl2MobileActive) {
            $footerLvl2MobileActive.classList.toggle("level2__mobile--active");
            $footerLevel1MobileActive.classList.toggle("level1__headline--active");
        }
    }
}
